module.exports = __webpack_public_path__ + "2ae15cc686d67c271d556aa692519543.MP3";